import { useForm } from "react-hook-form";
import ControllerSelect from "../../SharedComponents/formComponents/baseFormComponents/ControllerSelect";
import { FontEnum } from "../../SharedComponents/utils/enums/FontEnum";
import { useEffect, useState } from "react";
import ControllerTextInput from "../../SharedComponents/formComponents/baseFormComponents/ControllerTextInput";
import BaseButton from "../../SharedComponents/components/Buttons/BaseButton";
import { ButtonVariantEnum } from "../../SharedComponents/utils/enums/ButtonVariantEnum";
import PlusIconSVG from "../../SharedComponents/assets/icons/svg/PlusIconSVG";
import ControllerDatePicker from "../../SharedComponents/formComponents/baseFormComponents/ControllerDatePicker";
import { getSrcUrlFromFile } from "../../SharedComponents/utils/helpers/getSrcUrlFromFile";
import TrashBinIconSVG from "../assets/icons/svg/TrashBinIconSVG";
import CarInGarageIconSVG from "../assets/icons/svg/CarInGarageIconSVG";
import { useDispatch, useSelector } from "react-redux";
import { getGenerationsCar, getMakesCar, getModelsCar, getMotorsCar, resetCombosCar, resetCombosOnGenerationChange, resetCombosOnMakeChange, resetCombosOnModelChange } from "../reduxStore/entities/cars";
import AddUserCarInGarageModal from "../components/Modals/AddUserCarInGarageModal";
import { ulid } from "ulid";
import { createUserCar } from "../reduxStore/entities/userCars";


const AddUserCarInGarageForm = () => {
    const dispatch = useDispatch();

    const makes = useSelector((state) => state.cars.makes);
    const models = useSelector((state) => state.cars.models);
    const generations = useSelector((state) => state.cars.generations);
    const motors = useSelector((state) => state.cars.motors);

    const [selectedMake, setSelectedMake] = useState(null);
    const [selectedModel, setSelectedModel] = useState(null);
    const [selectedGeneration, setSelectedGeneration] = useState(null);
    const [selectedMotor, setSelectedMotor] = useState(null);


    useEffect(() => {
        const onLoad = () => {
            dispatch(resetCombosCar());
            dispatch(getMakesCar());
        };

        onLoad();
    }, []);


    const [isFormValid, setIsFormValid] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);

    const [addUserCarModalOpen, setAddUserCarModalOpen] = useState(false);


    useEffect(() => {
        const length = selectedImages?.length;

        if (length) {
            if (length > 3) {
                alert('Broj slika ne sme biti veci od 3');
                setSelectedImages((oldVal) => [...oldVal].slice(0, 3));
                return;
            }
        };

    }, [selectedImages]);

    const methods = useForm();
    const { control, getValues, setValue, watch } = methods;


    const values = watch();

    const handleSubmit = () => {
        const car_ulid = ulid();
        const formData = new FormData();

        formData.append("id_car_make", +values.carMakeId);
        formData.append("id_car_model", +values.carModelId);
        formData.append("id_car_generation", +values.carGenerationId);
        formData.append("id_car_motor", +values.carEngineId);
        formData.append("vin", values.vinNumber || "");
        formData.append("title", values.carDescription);
        formData.append("ulid", car_ulid);
        formData.append("last_registration_date", values.lastRegistrationDate?.toISOString() || "");

        formData.append("inGarage", 1);

        selectedImages.forEach((image) => {
            formData.append("images", image);
        });

        dispatch(createUserCar(formData));
        setAddUserCarModalOpen(false);
    };


    //Handle carMakeId change
    useEffect(() => {
        if (values.carMakeId) {
            dispatch(resetCombosOnMakeChange());
            dispatch(getModelsCar(values.carMakeId));
            setSelectedMake(makes.find((make) => make.value === values.carMakeId))

            setValue("carModelId", "");
            setValue("carGenerationId", "");
            setValue("carEngineId", "");
        };
    }, [values.carMakeId]);

    //Handle carModelId change
    useEffect(() => {
        if (values.carModelId) {
            dispatch(resetCombosOnModelChange());
            dispatch(getGenerationsCar(values.carModelId));
            setSelectedModel(models.find((model) => model.value === values.carModelId));

            setValue("carGenerationId", "");
            setValue("carEngineId", "");
        };
    }, [values.carModelId]);

    //Handle carGenerationId change
    useEffect(() => {
        if (values.carGenerationId) {
            dispatch(resetCombosOnGenerationChange());
            dispatch(getMotorsCar(values.carGenerationId));
            setSelectedGeneration(generations.find((generation) => generation.value === values.carGenerationId));

            setValue("carEngineId", "");
        };
    }, [values.carGenerationId]);


    //Handle carEngineId change
    useEffect(() => {
        if (values.carEngineId) {
            setSelectedMotor(motors.find((motor) => motor.value === values.carEngineId))
        };
    }, [values.carEngineId]);



    const GetSelectedImageStack = (file, setState) => {
        return (
            <div style={styles.vinNumberInputContainer}>
                <div style={styles.driversLicenceImageContainer}>
                    <img
                        src={getSrcUrlFromFile(file)}
                        style={styles.diversLicenceImage}
                    />

                    <div
                        onClick={setState}
                        style={styles.trashBinSvgContainer}
                    >
                        <TrashBinIconSVG />
                    </div>
                </div>

            </div>
        );
    };

    const GetSelectedImagesStack = () => {
        return selectedImages.map((file) => {
            const setStateCallback = (oldVal) => {
                return oldVal.filter((oldFile) => oldFile.name !== file.name);
            };

            return GetSelectedImageStack(file, () => setSelectedImages(setStateCallback));
        });
    };


    const selectedImagesAreNotEmpty = selectedImages.length > 0;

    return (
        <>
            {addUserCarModalOpen && (
                <AddUserCarInGarageModal
                    open={addUserCarModalOpen}
                    setOpen={setAddUserCarModalOpen}
                    carMake={selectedMake}
                    carModel={selectedModel}
                    carGeneration={selectedGeneration}
                    carMotor={selectedMotor}
                    vinNumber={values.vinNumber}
                    selectedImages={selectedImages}
                    onConfirm={handleSubmit}

                />
            )}

            <div style={styles.mainContainer}>
                <p style={styles.title}>
                    Unesi novi automobil za koji trazis deo
                </p>

                {/*
                    We are using mocked data for now 
                    Don't have any recorords in db, 
                    we should discuss about model
                */}

                <div style={styles.controllerTextInput}>
                    <ControllerTextInput
                        control={control}
                        name={"carDescription"}
                        placeholder={"Opisni naziv automobila"}
                        width={300}
                    />
                    <p style={styles.formFieldDescText}>
                        Opisite svoj auto radi lakseg pronalazenja
                    </p>
                </div>

                <div style={styles.controllerDatePicker}>
                    <ControllerDatePicker
                        control={control}
                        name={"lastRegistrationDate"}
                        label={"Datum poslednje registracije"}
                    />
                </div>

                <div style={styles.titleComponent}>
                    <p style={styles.title}>
                        Tehnicki podaci
                    </p>
                </div>

                <div style={styles.controllerSelect}>
                    <ControllerSelect
                        control={control}
                        name={"carMakeId"}
                        options={makes.map((make) => ({ label: make.name, value: make.value }))}
                        placeholder={"Marka automobila"}
                        width={300}
                    />

                    <ControllerSelect
                        control={control}
                        name={"carModelId"}
                        options={models.map((model) => ({ label: model.name, value: model.value }))}
                        placeholder={"Model"}
                        width={300}
                        disabled={models.length < 1}
                    />

                    <ControllerSelect
                        control={control}
                        name={"carGenerationId"}
                        options={generations.map((generation) => ({ label: generation.name, value: generation.value }))}
                        placeholder={"Godište / Generacija"}
                        width={300}
                        disabled={generations.length < 1}
                    />

                    <ControllerSelect
                        control={control}
                        name={"carEngineId"}
                        options={motors.map((motor) => ({ label: motor.name, value: motor.value }))}
                        placeholder={"Motor"}
                        width={300}
                        disabled={motors.length < 1}
                    />

                    <div>

                        <div style={styles.vinNumberInputContainer}>
                            <ControllerTextInput
                                control={control}
                                name={"vinNumber"}
                                placeholder={"Broj šasije (opciono, 17 karaktera)"}
                                width={300}
                            />

                            <p style={styles.baseStyleText}>
                                Za precizno pronalaženje delova, preporučujemo unos broja šasije
                            </p>
                        </div>

                    </div>
                </div>

                <div style={styles.titleComponent}>
                    <p style={styles.title}>
                        Slike
                    </p>

                    <div style={styles.imageComponent}>
                        {selectedImagesAreNotEmpty && (
                            GetSelectedImagesStack()
                        )}
                    </div>

                </div>


                <BaseButton
                    variant={ButtonVariantEnum.WHITE}
                    text={"Dodaj slike"}
                    IconComponent={PlusIconSVG}
                    type={"file"}
                    onClick={setSelectedImages}
                />


                <div style={styles.parkCarInGarage}>

                    <BaseButton
                        onClick={() => setAddUserCarModalOpen(true)}
                        variant={ButtonVariantEnum.BLACK}
                        text={"Parkiraj vozilo u garažu"}
                        IconComponent={CarInGarageIconSVG}
                    />

                </div>
            </div>
        </>
    )
};

export default AddUserCarInGarageForm;

const styles = {
    mainContainer: {
        marginTop: 30,
    },
    controllerTextInput: { marginTop: 30 },
    controllerDatePicker: { marginTop: 20 },
    controllerSelect: {
        display: 'flex',
        flexDirection: 'column',
        gap: 15
    },
    imageComponent: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginTop: 40
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "24px",
        fontWeight: 600,
        color: "#000000"
    },
    titleComponent: { marginTop: 40, marginBottom: 30 },
    driversLicenceImageContainer: {
        width: 75,
        height: 75,
        overflow: 'hidden',
        position: 'relative'
    },
    diversLicenceImage: {
        objectFit: 'cover',
        width: "100%",
        height: "100%",
        borderRadius: 4
    },
    trashBinSvgContainer: {
        position: 'absolute',
        cursor: 'pointer',
        backgroundColor: "#FFFFFF",
        bottom: 4,
        right: 4,
        paddingInline: 4,
        borderRadius: 4
    },
    formFieldDescText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de"
    },
    vinNumberInputContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: 'max-content'
    },
    purpleText: {
        cursor: "pointer",
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#5B21B6"
    },
    parkCarInGarage: {
        marginTop: 80,
        display: 'flex',
        alignItems: 'center',
        width: 'max-content',
        gap: 40
    },
    baseStyleText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.87)"
    }
};